const API_BASE = (process.env.VUE_APP_API_BASE || "").replace(/\/$/, "")

const resolveBackendPath = (path, useUploadsFallback = false) => {
  if (!path) return ""

  const normalizedPath = String(path).replace(/^\/+/, "")
  if (/^(https?:|data:|blob:)/i.test(normalizedPath)) return normalizedPath

  const normalizedApiBase = API_BASE.replace(/^\/+/, "")
  if (normalizedApiBase && (
    normalizedPath === normalizedApiBase
    || normalizedPath.startsWith(`${normalizedApiBase}/`)
  )) {
    return `/${normalizedPath}`
  }

  const backendPath = !useUploadsFallback || normalizedPath.startsWith("uploads/")
    ? normalizedPath
    : `uploads/${normalizedPath}`

  return `${API_BASE}/${backendPath}`
}

export const resolveUploadUrl = (path) => resolveBackendPath(path, true)

export const resolveNewsImageUrl = (noticia) => {
  if (noticia?.imagen_url) {
    return resolveBackendPath(noticia.imagen_url)
  }

  return resolveUploadUrl(noticia?.imagen)
}
